import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, Routes} from '@angular/router';
import {ToastrModule} from 'ng6-toastr-notifications';
import {A11yModule} from '@angular/cdk/a11y';
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {PCMissingTranslationHelper} from './shared/handler/missing-translation.handler';
import {SharedModule} from './shared/shared.module';
import {AuthModule} from './shared/auth/auth.module';
import {LoginPageComponent} from './shared/auth/login/login-page.component';
import {AuthGuard} from './shared/auth/guards/auth.guard';
import {HttpErrorInterceptor} from './shared/interceptors/http-error-interceptor.service';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


const appRoutes: Routes = [
    {
        path: 'login', component: LoginPageComponent
    },
    {
        path: '',
        loadChildren: () =>
            import('./modules/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard]
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        A11yModule,
        SharedModule,
        AuthModule,
        ToastrModule.forRoot(),
        RouterModule.forRoot(
            appRoutes
        ),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader, // exported factory function needed for AoT compilation,
                deps: [HttpClient]
            },
            missingTranslationHandler: {provide: MissingTranslationHandler, useClass: PCMissingTranslationHelper}
        })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
